export function add_filter_class() {
  if ($('#FilterWrapper').length && !$('#FilterWrapper #SortAndPageSettings').hasClass('filter-panel-open')) {
    $('#FilterWrapper #SortAndPageSettings').addClass('filter-panel-open');
  }
  if ($('#FilterWrapper').length && !$('#FilterWrapper #FilterContentWrapper').hasClass('filter-panel-open')) {
    $('#FilterWrapper #FilterContentWrapper').addClass('filter-panel-open');
  }
}
